import { Commit } from './Commit';
import { PullRequest } from './PullRequest';

export interface PipelineImportedFrom {
  repo_uuid: string;
  revision: string;
}

export type PIPELINE_TARGET_TYPE_COMMIT = 'pipeline_commit_target';
export type PIPELINE_TARGET_TYPE_REFERENCE = 'pipeline_ref_target';
export type PIPELINE_TARGET_TYPE_PULL_REQUEST = 'pipeline_pullrequest_target';
export type PIPELINE_TARGET_TYPE_UNKNOWN = 'pipeline_unknown_target';
export type PIPELINE_TARGET_TYPE =
  | PIPELINE_TARGET_TYPE_UNKNOWN
  | PIPELINE_TARGET_TYPE_COMMIT
  | PIPELINE_TARGET_TYPE_REFERENCE
  | PIPELINE_TARGET_TYPE_PULL_REQUEST;

export type TARGET_SELECTOR_TYPE =
  | 'branches'
  | 'tags'
  | 'bookmarks'
  | 'default'
  | 'custom'
  | 'pull-requests'
  | 'imported_from';

export interface PipelineSelector {
  type?: TARGET_SELECTOR_TYPE;
  pattern?: string;
  imported_from?: PipelineImportedFrom;
}

export interface PipelineTarget {
  type?: PIPELINE_TARGET_TYPE;
  commit?: Commit;
  selector?: PipelineSelector;
}

export interface PipelineCommitTarget extends PipelineTarget {
  type: PIPELINE_TARGET_TYPE_COMMIT;
  pattern: string;
}

export interface PipelinePullRequestTarget extends PipelineTarget {
  type: PIPELINE_TARGET_TYPE_PULL_REQUEST;
  source: string;
  destination: string;
  destination_commit: Commit;
  pullrequest: PullRequest;
}

export interface PipelineReferenceTarget extends PipelineTarget {
  type: PIPELINE_TARGET_TYPE_REFERENCE;
  ref_type: string;
  ref_name: string;
}

export interface PipelineUnknownTarget extends PipelineTarget {
  type: PIPELINE_TARGET_TYPE_UNKNOWN;
}
